"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../../../common/constants/constants");
var useUserComingFromMyAccount = function () {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var from = urlParams.get(constants_1.constants.FROM);
    var isUserComingFromMyAccount = from === 'my-account';
    return { isUserComingFromMyAccount: isUserComingFromMyAccount };
};
exports.default = useUserComingFromMyAccount;
